import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=aeea4e80&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=aeea4e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeea4e80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/l-setting-for-configuration-tool/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aeea4e80')) {
      api.createRecord('aeea4e80', component.options)
    } else {
      api.reload('aeea4e80', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=aeea4e80&scoped=true&", function () {
      api.rerender('aeea4e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UIComponents/Footer.vue"
export default component.exports